// const card_galls = document.querySelectorAll('.card-gallery');


// card_galls.forEach(card_gall => {
//     card_gall.addEventListener
// })

//Preorder logic
const preOrderLogic = function () {
    const preorderMain = document.querySelector('.preorder-agre');
    const preorderChb = document.querySelector('#preorder');
    const atcBtn = document.querySelector('add-to-cart-component .add-to-cart-button');
   
    atcBtn.setAttribute('disabled','');

    const updateAtc = function () {
        if(this.checked) {
            preorderMain.classList.add('rdc-active');
            atcBtn.removeAttribute('disabled');
        } else {
            preorderMain.classList.remove('rdc-active');
            atcBtn.setAttribute('disabled','');
        }
    }
    preorderChb.addEventListener('change',updateAtc);
}

// preOrderLogic();
